export default [
    {
      value: "Proponente",
      text: "Proponente",
    },
    {
      value: "Executora",
      text: "Executora",
    },
    {
      value: "Parceira",
      text: "Parceira",
    },
];